export const contentOperationsProduct = {
  name: 'Content Hub Operations',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    'Collaborate effortlessly on content strategy, creation and analytics with an intelligent content operations solution.',

  link: {
    type: 'external-link',
    to: '{baseUrl}?tenantId={tenantId}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: '$.annotations.URL',
          resource: 'tenant',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/1e60e629527e4adb8acdec7f89938649?v=5e09cc58',
  },
  color: 'purple',
};
